import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const OrderRequestedsEdit = props => (
  <Edit {...props} resource="orderRequesteds">
    <Form />
  </Edit>
);

OrderRequestedsEdit.propTypes = {};

export default OrderRequestedsEdit;
